module.exports = __webpack_public_path__ + "static/media/login-bg.063f053f.png";